import StringConstants from '../../constants/StringConstants';

export function getAccountInfoContent(account) {
  return {
    BALANCE_LABEL: 'Balance',
    REMAINING_LABEL: 'Remaining',
    ACC_NAME_LABEL:
      account.type === 'credit_card' ? 'Credit Card Number' : 'Account number',
    ...(account.product.code !== StringConstants.KAPITI_PRODUCT_CODE && {
      ACC_SORTCODE_LABEL: 'Sortcode',
    }),
  };
}
